export default "__VITE_ASSET__BtB17chC__"